import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import AddPayoutMethod from "../../../../components/Modals/CoachFlow/OnBoarding/AddPayoutMethod/AddPayoutMethod";
import { RemovePayoutMethodModal } from "../../../../components/Modals/CoachFlow/Settings/RemovePayoutMethod/RemovePayoutMethod";
import { Button } from "../../../../stories/Button/Button";
import classes from "./PayoutMethod.module.css";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import PaymentMethodCard from "../../../../stories/PaymentMethodCard/PaymentMethodCard";
import { Payment } from "../../../../constant/imagePath";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import PayoutMethodMobile from "./PayoutMethodMobile";

const PayoutMethodDesktop = () => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const paymentarray = [
    {
      type: "master",
      title: "Master Card",
      number: ".... 3679",
      description: "This is your default payment method",
      default: true,
    },
    {
      type: "visa",
      title: "Visa Card",
      number: ".... 6543",
      description: "",
    },
  ];
  return (
    <div>
      <Row className={["g-0"].join(" ")}>
        <Col md={8}>
          <Row className={["g-0", classes.paymentCards].join(" ")}>
            {paymentarray.map((item, i) => {
              return (
                <Col md={12} key={i}>
                  <PaymentMethodCard
                    data={item}
                    onRemove={() => setIsRemoving(true)}
                  />
                </Col>
              );
            })}
          </Row>
          <div className={[classes.addpaymentbtn].join(" ")}>
            <Button
              primary={false}
              size="Large"
              customStyle={{ width: "max-content" }}
              onClick={() => setIsAdding(true)}
            >
              Add new payment method
            </Button>
          </div>
        </Col>

        <Col md={4} className={[classes.pl36].join(" ")}>
          <div className={[classes.paylayoutdiv].join(" ")}>
            <img
              src={Payment}
              alt="..."
              className={[classes.paymentimg, classes.mb16].join(" ")}
            />
            <h6
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={[classes.mb8].join(" ")}
            >
              Make all payouts
              through Lytesnap
            </h6>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
              Always pay and communicate through Lytesnap to ensure you're protected under our {" "}<span
                style={{ color: Colors.mainBlue }}
                className={[classes.pointer].join(" ")}
              >
                Terms of Service
              </span>
              , cancellation, and other safeguards.
            </p>
          </div>
        </Col>
      </Row>
      {/* Below modal is shown when payment cancel on stripe modal  */}
      <RemovePayoutMethodModal show={isRemoving} setShow={setIsRemoving} />
      <AddPayoutMethod show={isAdding} setShow={setIsAdding} />
    </div>
  );
};

const PayoutMethod = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PayoutMethodMobile /> : <PayoutMethodDesktop />;
};

export default PayoutMethod;
